import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { ThemeProvider } from "@/context/ThemeContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Ordini from "@/pages/Ordini";
import Magazzino from "@/pages/Magazzino";
import Vendite from "@/pages/Vendite";
import Produzione from "@/pages/Produzione";
import MateriePrime from "@/pages/MateriePrime";
import Richieste from "@/pages/Richieste";
import Social from "@/pages/Social";
import Logistica from "@/pages/Logistica";
import Resi from "@/pages/Resi";
import Clienti from "@/pages/Clienti";
import Utenti from "@/pages/Utenti";
import Attivita from "@/pages/Attivita";
import Modellistica from "@/pages/Modellistica";
import SchedaStampa from "@/pages/SchedaStampa";
import TaglioStampa from "@/pages/TaglioStampa";
import { Toaster } from "@/components/ui/sonner";

const pages = [
  { path: "/", el: <Dashboard />, panel: "dashboard" },
  { path: "/ordini", el: <Ordini />, panel: "ordini" },
  { path: "/clienti", el: <Clienti />, panel: "clienti" },
  { path: "/magazzino", el: <Magazzino />, panel: "magazzino" },
  { path: "/vendite", el: <Vendite />, panel: "vendite" },
  { path: "/resi", el: <Resi />, panel: "resi" },
  { path: "/produzione", el: <Produzione />, panel: "produzione" },
  { path: "/materie-prime", el: <MateriePrime />, panel: "materie_prime" },
  { path: "/modellistica", el: <Modellistica />, panel: "modellistica" },
  { path: "/richieste", el: <Richieste />, panel: "richieste" },
  { path: "/social", el: <Social />, panel: "social" },
  { path: "/logistica", el: <Logistica />, panel: "logistica" },
  { path: "/attivita", el: <Attivita />, panel: "attivita" },
  { path: "/utenti", el: <Utenti />, panel: "utenti" },
];

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/modellistica/tagliato/:id/stampa" element={<ProtectedRoute panel="modellistica"><TaglioStampa /></ProtectedRoute>} />
            <Route path="/modellistica/:id/stampa" element={<ProtectedRoute panel="modellistica"><SchedaStampa /></ProtectedRoute>} />
            {pages.map((p) => (
              <Route
                key={p.path}
                path={p.path}
                element={
                  <ProtectedRoute panel={p.panel}>
                    <Layout>{p.el}</Layout>
                  </ProtectedRoute>
                }
              />
            ))}
          </Routes>
          <Toaster position="top-right" richColors />
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
